import { Injectable, Inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../_services/authentication.service';
import { AppConfig } from '../app.config';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {

  constructor(private router: Router, private appConfig: AppConfig, private authenticationService: AuthenticationService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authenticationService.isAuthenticated().then((authenticated: boolean) => {
      if (authenticated) {
        return true;
      } else {
       this.router.navigate(['/access/login']);
     //   window.location.href = this.appConfig.SERVER_URL + '/access/login';
      }
    });
  }
}
